export enum ConditionType {

    BOOLEAN_EQUALS          = 'boolean-equals',

    NOT_NULL                = 'not-null',
    IS_NULL                 = 'is-null',

    INCLUDES                = 'includes',
    EXCLUDES                = 'excludes',

    ARRAY_INTERSECTION      = 'array-intersection',

    NUMBER_GREATER_THAN     = 'number-greater-than',
    NUMBER_LESS_THAN        = 'number-less-than',
    NUMBER_EQUALS           = 'number-equals',

    STRING_EQUALS           = 'string-equals',
    STRING_CONTAINS         = 'string-contains',

    DATE_FIXED_BEFORE       = 'date-fixed-before',
    DATE_FIXED_AFTER        = 'date-fixed-after',
    DATE_FIXED_EQUALS       = 'date-fixed-equals',
    DATE_FIXED_RANGE        = 'date-fixed-range',

    DATE_RELATIVE_RANGE     = 'date-relative-range',
    DATE_RELATIVE_AFTER     = 'date-relative-after',
    DATE_RELATIVE_BEFORE    = 'date-relative-before',
    DATE_RELATIVE_EQUALS    = 'date-relative-equals',
    DATE_RELATIVE_PERIOD    = 'date-relative-period',
}

export function IConditionTypeFactory(conditionType:ConditionType):typeof IConditionType {

    switch (conditionType) {

        case ConditionType.NOT_NULL             : return ConditionType_NotNull
        case ConditionType.IS_NULL              : return ConditionType_IsNull

        case ConditionType.INCLUDES             : return ConditionType_Includes
        case ConditionType.EXCLUDES             : return ConditionType_Excludes
        case ConditionType.ARRAY_INTERSECTION   : return ConditionType_ArrayIntersection

        case ConditionType.NUMBER_EQUALS        : return ConditionType_NumberEquals
        case ConditionType.NUMBER_GREATER_THAN  : return ConditionType_NumberGreaterThan
        case ConditionType.NUMBER_LESS_THAN     : return ConditionType_NumberLessThan

        case ConditionType.STRING_EQUALS        : return ConditionType_StringEquals
        case ConditionType.STRING_CONTAINS      : return ConditionType_StringContains

        case ConditionType.DATE_RELATIVE_RANGE  : return ConditionType_DateRelativeRange
        case ConditionType.DATE_RELATIVE_AFTER  : return ConditionType_DateRelativeAfter
        case ConditionType.DATE_RELATIVE_BEFORE : return ConditionType_DateRelativeBefore
        case ConditionType.DATE_RELATIVE_EQUALS : return ConditionType_DateRelativeEquals
        case ConditionType.DATE_RELATIVE_PERIOD : return ConditionType_DateRelativePeriod

        case ConditionType.DATE_FIXED_BEFORE    : return ConditionType_DateFixedBefore
        case ConditionType.DATE_FIXED_AFTER     : return ConditionType_DateFixedAfter
        case ConditionType.DATE_FIXED_EQUALS    : return ConditionType_DateFixedEquals
        case ConditionType.DATE_FIXED_RANGE     : return ConditionType_DateFixedRange

        case ConditionType.BOOLEAN_EQUALS       : return ConditionType_BooleanEquals

        default:
            console.error("UNKNWON CONDITON TYPE in factory #3djasdw type=", conditionType)
            return IConditionType
    }

}

export enum ConditionValueType {
    ARRAY_ID                        = 'array-id',
    NUMBER                          = 'number',
    STRING                          = 'string',
    OBJECT_DATE_RANGE_RELATIVE      = 'object-date-relative',
    DATE_RELATIVE                   = 'date-relative',
    DATE_RELATIVE_PERIOD            = 'date-relative-period',
    MOMENT_DATE                     = 'moment-date',
    DATE_RANGE                      = 'date-range',
    VOID                            = 'void',
    BOOLEAN                         = 'boolean'
}

export class IConditionType {
    static type         : ConditionType
    static label        : string
    static groupHeader? : string
    static valueType    : ConditionValueType

    public static toOption():Option {
        return {
            value   : this.type,
            label   : this.label
        }
    }
}

// NULL

export class ConditionType_IsNull extends IConditionType {
    static type         = ConditionType.IS_NULL
    static label        = 'Not set'
    static valueType    = ConditionValueType.VOID
}

export class ConditionType_NotNull extends IConditionType {
    static type         = ConditionType.NOT_NULL
    static label        = 'Set'
    static valueType    = ConditionValueType.VOID
}


// BOOLEAN

export class ConditionType_BooleanEquals extends IConditionType {
    static type         = ConditionType.BOOLEAN_EQUALS
    static label        = 'Is'
    static valueType    = ConditionValueType.BOOLEAN
}

// ARRAYS

export class ConditionType_Includes extends IConditionType {
    static type         = ConditionType.INCLUDES
    static label        = 'Is one of'
    static valueType    = ConditionValueType.ARRAY_ID
}

export class ConditionType_Excludes extends IConditionType {
    static type         = ConditionType.EXCLUDES
    static label        = 'Is NOT one of'
    static valueType    = ConditionValueType.ARRAY_ID
}

export class ConditionType_ArrayIntersection extends IConditionType {
    static type         = ConditionType.ARRAY_INTERSECTION
    static label        = 'Is one of'
    static valueType    = ConditionValueType.ARRAY_ID
}

// NUMBERS

export class ConditionType_NumberGreaterThan extends IConditionType {
    static type         = ConditionType.NUMBER_GREATER_THAN
    static label        = 'Greater than'
    static valueType    = ConditionValueType.NUMBER
}

export class ConditionType_NumberLessThan extends IConditionType {
    static type         = ConditionType.NUMBER_LESS_THAN
    static label        = 'Less than'
    static valueType    = ConditionValueType.NUMBER
}

export class ConditionType_NumberEquals extends IConditionType {
    static type         = ConditionType.NUMBER_EQUALS
    static label        = 'Equals'
    static valueType    = ConditionValueType.NUMBER
}

// STRING

export class ConditionType_StringEquals extends IConditionType {
    static type         = ConditionType.STRING_EQUALS
    static label        = 'Equals'
    static valueType    = ConditionValueType.STRING
}

export class ConditionType_StringContains extends IConditionType {
    static type         = ConditionType.STRING_CONTAINS
    static label        = 'Contains'
    static valueType    = ConditionValueType.STRING
}

// DATE RELATIVE

export class ConditionType_DateRelativeBefore extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_BEFORE
    static label        = 'Before'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE
}

export class ConditionType_DateRelativeAfter extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_AFTER
    static label        = 'After'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE
}

export class ConditionType_DateRelativeRange extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_RANGE
    static label        = 'In range'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.OBJECT_DATE_RANGE_RELATIVE
}

export class ConditionType_DateRelativeEquals extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_EQUALS
    static label        = 'Is'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE
}

export class ConditionType_DateRelativePeriod extends IConditionType {
    static type         = ConditionType.DATE_RELATIVE_PERIOD
    static label        = 'In period'
    static groupHeader  = 'Relative date'
    static valueType    = ConditionValueType.DATE_RELATIVE_PERIOD
}

// DATE FIXED

export class ConditionType_DateFixedBefore extends IConditionType {
    static type         = ConditionType.DATE_FIXED_BEFORE
    static label        = 'Before'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.MOMENT_DATE
}

export class ConditionType_DateFixedAfter extends IConditionType {
    static type         = ConditionType.DATE_FIXED_AFTER
    static label        = 'After'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.MOMENT_DATE
}

export class ConditionType_DateFixedEquals extends IConditionType {
    static type         = ConditionType.DATE_FIXED_EQUALS
    static label        = 'Is'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.MOMENT_DATE
}

export class ConditionType_DateFixedRange extends IConditionType {
    static type         = ConditionType.DATE_FIXED_RANGE
    static label        = 'In range'
    static groupHeader  = 'Fixed date'
    static valueType    = ConditionValueType.DATE_RANGE
}